import { Analytics as AnalyticsModule } from "../modules/Analytics/Analytics";

const Analytics = () => {
  return <AnalyticsModule />;
};

export default Analytics;
